import React from "react";

const Unarchive = props => {
  return (
    <svg width="20" height="18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#838383" d="M1 6h18v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6z" />
        <g fill="#FFF">
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth="3"
            d="M10 11.93v2.64"
          />
          <path d="M10 8l3 3.43H7z" />
        </g>
        <path fill="#838383" d="M0 3h20V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v1z" />
      </g>
    </svg>
  );
};

export default Unarchive;
